if (!customElements.get("product-layout-switch")) {
  customElements.define(
    "product-layout-switch",
    class ProductLayoutSwitch extends HTMLElement {
      connectedCallback() {
        this.storageKey = this.dataset.storageKey;
        this.buttons = this.querySelectorAll("[data-product-layout]");
        this.handleClick = this.handleClick.bind(this);

        this.buttons.forEach((button) => {
          button.addEventListener("click", this.handleClick);
        });

        this.applyLayout(this.getStoredLayout());
      }

      disconnectedCallback() {
        this.buttons.forEach((button) => {
          button.removeEventListener("click", this.handleClick);
        });
      }

      getStoredLayout() {
        try {
          const storedLayout = localStorage.getItem(this.storageKey);
          return storedLayout === "list" ? "list" : "grid";
        } catch {
          return "grid";
        }
      }

      handleClick(event) {
        const layout = event.currentTarget.dataset.productLayout;

        try {
          localStorage.setItem(this.storageKey, layout);
        } catch {
          // The view still changes for the current page when storage is unavailable.
        }
        this.applyLayout(layout);
      }

      applyLayout(layout) {
        const grid = document.getElementById("product-grid");
        if (!grid) return;

        grid.classList.toggle("collection__grid--list", layout === "list");
        this.buttons.forEach((button) => {
          button.setAttribute(
            "aria-pressed",
            button.dataset.productLayout === layout ? "true" : "false",
          );
        });
      }
    },
  );
}
